import styled from 'styled-components';
import colors from '@theme/colors';

const UpperBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const List = styled.div`
  margin-top: 20px;
`;
const ListTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  > *:not(:first-child) {
    margin-left: 20px;
  }
`;

const inkBarStyle = {
  backgroundColor: colors.BRIGHT_YELLOW,
};

const tabItemContainerStyle = {
  backgroundColor: colors.LIGHT_BLUE,
};

export default {
  UpperBarContainer,
  List,
  ListTitle,
  inkBarStyle,
  tabItemContainerStyle,
};



// WEBPACK FOOTER //
// ./components/layout/Home.js